export default "__VITE_ASSET__f34e5b3f__"